import { axios } from '@/utils/request'
import ipConfig from '../../config/ip.config'
export const api = {
  getCusAgreement: ipConfig.api_mwclg + '/mcp/user/getCusAgreement'
}

// 获取客户协议
export function getCusAgreement (params) {
  return axios({
    url: api.getCusAgreement,
    method: 'post',
    data: params
  })
}
